export const cssGlobal = {
  getStatus: function(param, type = "default") {
    const maps = {
      product: {
        "Hors stock": "#f83e70",
        "En stock": "#3cd1c2",
        Précommande: "#3cd1c2",
        Réapprovisionnement: "#ffaa2c",
      },
      quote: {
        Brouillon: "#bdc3c7",
        "Attente Client": "#ffaa2c",
        Accepté: "#3cd1c2",
        Refusé: "#f83e70",
      },
    };

    if (maps[type]) return maps[type][param];

    const defaultMap = {
      overdue: "#f83e70",
      "Non livré": "#f83e70",
      "Non pris en charge": "#f83e70",
      Impayé: "#f83e70",
      "En attente": "#f83e70",
      ongoing: "#ffaa2c",
      "En cours": "#ffaa2c",
    };

    return defaultMap[param] || "#3cd1c2";
  },
  getBool: function(param, color) {
    if (param)
      if (color)
        return "#3cd1c2";
      else
        return "Oui";

    else
      if (color)
        return "#f83e70";
      else
        return "Non";
  },
};
